import { Line  } from 'vue-chartjs'
import zoomPlugin from 'chartjs-plugin-zoom';

export default {
  extends: Line,
  props: ['chart', 'display'],
  watch: {
    chart: function () {
      
      this.renderChart({
        labels: this.chart.labels,
        datasets: this.chart.datasets,
      }, {
        responsive: true, maintainAspectRatio: false , legend: {
          display: this.display
          
        },
      })
    }
  },
  computed: {
    chartData: function () {
      
      return this.chart;
    },
    options() {
      return {
        responsive: true,
        maintainAspectRatios: false,

        legend: {
          display: this.display
        },
        scales: {
          xAxis: [{
            ticks: {
              callback: (value, index, values) => {
                var arridx = value.split(" ")
               // console.log(arridx)
                return arridx[1];
              },
            },
          }],
        },
        
        tooltips: {
          enabled: true,
           
          callbacks: {
            label: ((tooltipItems, data) => {
              return tooltipItems.yLabel + ' ' + data.datasets[tooltipItems.datasetIndex].label;
            })
          }
        }
      }
    }
  },
  mounted() {
    Line.register(zoomPlugin);
    this.addPlugin(zoomPlugin);
    this.renderChart({
      labels: this.chart.labels,
      datasets: this.chart.datasets,
       
    }, this.options)
  }
}